import { Navigate, useLocation } from "react-router-dom";

function normalizeRole(rawRole) {
  return String(rawRole || "")
    .trim()
    .toLowerCase();
}

export default function RequireModerator({ children }) {
  const loc = useLocation();

  const userId = localStorage.getItem("userId");
  const roleFromStorage = normalizeRole(localStorage.getItem("role"));
  const isModerator = !!userId && ["mod", "admin", "superadmin"].includes(roleFromStorage);

  if (!isModerator) {
    const to = userId ? "/dashboard" : "/login";
    return <Navigate to={to} replace state={{ from: loc }} />;
  }

  return children;
}
